<vn-menu-item
    [section]="MenuSection.BalanceBreakdown"
    [item]="item"
    [processClick]="false"
    (click)="processClick($event, item)"
    class="bb-btn-wrapper" />
